module.exports = __webpack_public_path__ + "img/drug-35.ffbadfac.png";